<template>
  <v-dialog
    v-model="show" 
    max-width="530px">
    <v-card>
      <v-card-title class="fibl-headline dialog-text pa-5">
        {{ $t('newDemandFulfillmentDialog.title') }}
      </v-card-title>
    <v-card-text class="pa-5 dialog-text">
        <v-text-field
          ref="nameField"
          v-model="name"
          required
          label="Name"
          autofocus
          @keypress.enter="close(true)"
          />

    </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn text @click="close(false)" class="button__secondary">
          {{ $t('newDemandFulfillmentDialog.buttonFalse') }}
        </v-btn>
        <v-btn 
          class="button__primary" 
          text 
          @click="close(true)"
          :disabled="!name"
          >
          {{ $t('newDemandFulfillmentDialog.buttonTrue') }}
        </v-btn>
        <v-spacer> </v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  name: "NewDemandFulfillmentDialog",

  props: ["visible"],

  data () {
    return {
      name: null
    }
  },

 computed: {
    ...mapState(['project']),

    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
    
  methods: {
    ...mapMutations(['addNewDemandFulfillment']),

    close(val) {
      if (val) {
        this.addNewDemandFulfillment({name: this.name, id: null});
      }

      if(!val){
        this.$store.state.project = null;
      }
      this.show = false;
      this.name = null;
    },
  }

  
};
</script>
